"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutlineUtils = void 0;
var core_1 = require("@inter-ikea-core/core");
var AddBlockingToAllModelsSystem_1 = require("./AddBlockingToAllModelsSystem");
var SimpleOutlineAssemblySystem_1 = require("./SimpleOutlineAssemblySystem");
var SimpleOutlineBlockingSystem_1 = require("./SimpleOutlineBlockingSystem");
var SimpleOutlineModelSystem_1 = require("./SimpleOutlineModelSystem");
var SimpleOutlineSelectedSystem_1 = require("./SimpleOutlineSelectedSystem");
var SimpleOutlineSnapshotLoadedSystem_1 = require("./SimpleOutlineSnapshotLoadedSystem");
/**
 * Util class that helps our users with setting up the outline systems for their required
 * feature sets.
 */
exports.OutlineUtils = {
    /**
     * Enables all systems necessary for showing outlines on selected entities. It will handle
     * automatically outline parts of assemblies if the assembly itself is outlined.
     *
     * Outlines will be shown as block outlines.
     *
     * @param entityManager The entity manager where the systems should be registered
     */
    enableOutlineSystem: function (entityManager) {
        new SimpleOutlineBlockingSystem_1.SimpleOutlineBlockingSystem().register(entityManager);
        new SimpleOutlineSelectedSystem_1.SimpleOutlineSelectedSystem().register(entityManager);
        new SimpleOutlineAssemblySystem_1.SimpleOutlineAssemblySystem().register(entityManager);
        new SimpleOutlineModelSystem_1.SimpleOutlineModelSystem().register(entityManager);
        new SimpleOutlineSnapshotLoadedSystem_1.SimpleOutlineSnapshotLoadedSystem().register(entityManager);
    },
    /**
     * This is similar to enableOutlineSystem, but assembly parts will not be automatically outlined.
     * @param entityManager
     */
    enableSimpleOutlineSystem: function (entityManager) {
        new SimpleOutlineBlockingSystem_1.SimpleOutlineBlockingSystem().register(entityManager);
        new SimpleOutlineSelectedSystem_1.SimpleOutlineSelectedSystem().register(entityManager);
        new SimpleOutlineModelSystem_1.SimpleOutlineModelSystem().register(entityManager);
        new SimpleOutlineSnapshotLoadedSystem_1.SimpleOutlineSnapshotLoadedSystem().register(entityManager);
    },
    /**
     * @deprecated The old outline system is deprecated, use setupOutlineSystem or setupSimpleOutlineSystem instead.
     */
    enableDeprecatedOutlineSystem: function (entityManager, coreServices) {
        var blockingSystem = new AddBlockingToAllModelsSystem_1.AddBlockingToAllModelsSystem();
        coreServices.entityManager.registerSystem(blockingSystem);
        blockingSystem.enable();
        var outlineSystem = new core_1.OutlineSystem();
        coreServices.entityManager.registerSystem(outlineSystem);
    }
};
//# sourceMappingURL=OutlineUtils.js.map